import { render } from "./liquidity-mining.vue?vue&type=template&id=5a5a14f4&ts=true"
import script from "./liquidity-mining.vue?vue&type=script&lang=ts"
export * from "./liquidity-mining.vue?vue&type=script&lang=ts"

import "./liquidity-mining.vue?vue&type=style&index=0&id=5a5a14f4&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__